/**
 * Interface for key/value storage
 */ /**
 * The type of persisted storage
 *
 * Note: The values are reserved strings. Do not change them.
 */ export var StorageType = /*#__PURE__*/ function(StorageType) {
    /** Local storage */ StorageType["LocalStorage"] = "localStorage";
    /** Session storage */ StorageType["SessionStorage"] = "sessionStorage";
    return StorageType;
}({});
